import { useContext } from "react"
import { MdMenuBook } from "react-icons/md"
import { AppContext } from "../App"
import { CDN_URL, formatDate } from "../Helpers"


export default function LibraryItemCard({ data }) {

  const appContext = useContext(AppContext);
  const type = String(data.itemType || '').toLowerCase();

  function openContent() {
    appContext.navTo({
      item: 'view',
      subItem: 'library-content',
      extraItem: data.uuid,
    })
  }

  return (
    <div className="card library-item-card h-100" onClick={openContent}>
      <div className="library-item-cover">
        <img src={CDN_URL + data.item.coverPhoto} alt={data.item.title} />
        <span className="marketplace-type-badge">{type}</span>
      </div>
      <div className="card-body d-flex flex-column">
        <h6>{data.item.title}</h6>
        <p className="library-item-date">Purchased {formatDate(data.paymentConfirmedDate)}</p>
        <button className="btn btn-primary btn-rounded mt-auto">
          <MdMenuBook size={20}/> Open Content
        </button>
      </div>
    </div>
  )
}
